import { DatePipe } from '@angular/common';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Constants } from '../../_model/constants';
import { FilterDto } from '../../_model/filterDto';
import { MultipleFilterProperty } from '../../_model/multiple-filter-property';
import { TableResponse } from '../../_model/table-response/table-response';
import { UserService } from "../user.service";
import { PageParams } from "./page-params";
import { POSDownload } from '../../_model/downloadPos/POSDownload';
import { POSResponse } from '../../_model/downloadPos/pos-response';
import { History } from '../../_model/history-response/history';
import { InvoiceDownload } from '../../_model/downloadPos/invoice';
import { LoginStateService } from '../../pages/login/login-state.service';
@Injectable({
  providedIn: 'root'
})
export abstract class TableService {

  baseUrl!: string;
  multilpleFilterBaseUrl!: string;
  downloadPOSUrl!: string;
  downloadInvoiceUrl!: string;
  filterDto: Array<FilterDto> = [];
  filterArray: Array<MultipleFilterProperty> = [];
  isWorkOrderRoute = false;

  constructor(private http: HttpClient, private userService: UserService,
    private router: Router, public datepipe: DatePipe, private loginStateService: LoginStateService) {
  }

  getTableData(filters: FormGroup,brand: string, page: number, size: number): Observable<TableResponse> {
    const pageParams = PageParams.getPageParams(page, size);
    let url = this.userService.getClientBaseUrl() + '/brand/' +  brand + this.baseUrl;
    this.checkWorkOrderRoute();

    if (this.isWorkOrderRoute && (filters && (typeof filters.value.multipleFilterarray != "undefined"
      && filters.value.multipleFilterarray != null
      && filters.value.multipleFilterarray.length != null
      && filters.value.multipleFilterarray.length > 0))) {
      url = this.userService.getClientBaseUrl() + '/brand/' + brand  + this.multilpleFilterBaseUrl;
      this.createBody(filters);
      let body = {
        filterListDTO: this.filterDto
      };
      this.filterDto = [];
      return this.http.post<TableResponse>(url, body, { params: pageParams });
    }
    else if (filters && filters.value.tableFilter?.column === "workOrderNumber") {
      url = this.userService.getClientAndFmSystemBaseUrl() + '/brand/' + brand + '/workorderlist';
      let body = {
        "woList":
          filters.value.value
      };
      this.filterDto = [];
      return this.http.post<TableResponse>(url, body, { params: pageParams });
    }
    else if (filters && filters.value.tableFilter?.column === "workOrderId") {
      url = this.userService.getClientAndFmSystemBaseUrl() + '/brand/' + brand +  '/visitlist';
      let body = {
        "woList":
          filters.value.value
      };
      this.filterDto = [];
      return this.http.post<TableResponse>(url, body, { params: pageParams });
    }
    else {
      if (filters && filters.value && filters.value.tableFilter && filters.value.value) {
        url = url + '/property/' + filters.value.tableFilter.column + '/value/' + filters.value.value;
      }

      return this.http.get<TableResponse>(url, { params: pageParams });
    }
  }

  private createBody(filters: FormGroup) {
    filters.value.multipleFilterarray.forEach((element: MultipleFilterProperty) => {
      let dto = new FilterDto();

      if (element.column == Constants.dateConst) {
        if (element.dateBackendName == Constants.dateReceived) {
          dto.property = Constants.backendDateReceived;
        } else {
          dto.property = Constants.backendScheduledStartDate;
        }

        let start_date = this.datepipe.transform(element.origionalStartDateFormat, Constants.backendDateFormat);
        let end_date = this.datepipe.transform(element.origionalEndDateFormat, Constants.backendDateFormat);
        dto.value = start_date + " = " + end_date;
      } else {
        dto.property = element.column;
        dto.value = element.value;
      }

      this.filterDto.push(dto);
    });
  }

  checkWorkOrderRoute(): void {
    if (this.router.url === '/' || this.router.url === '/visits') {
      this.isWorkOrderRoute = true;
    } else {
      this.isWorkOrderRoute = false;
    }
  }

  downloadPOS(workOrderId: string, workOrderNumber: string,visitId: any, visitState: any,brand:string): Observable<POSResponse> {

    let updateurl = this.userService.getClientAndFmSystemBaseUrl() + '/brand/' + brand  + this.downloadPOSUrl;
    let posDownload = new POSDownload();
    posDownload.workOrderId = workOrderId;
    posDownload.workOrderNumber = workOrderNumber;
    posDownload.visitId = visitId || null;
    posDownload.visitState = visitState || null;

    return this.http.post<POSResponse>(updateurl, posDownload);

  }

   downloadVisitPOS(workOrderId: string, workOrderNumber: string, visitId: string, visitState: string, brand: string): Observable<POSResponse> {

    let updateurl = this.userService.getClientAndFmSystemBaseUrl() + '/brand/' + brand  + this.downloadPOSUrl;
    let posDownload = new POSDownload();
    posDownload.workOrderId = "0";
    posDownload.workOrderNumber = workOrderNumber || "";
    posDownload.visitId = visitId;
    posDownload.visitState = visitState;

    return this.http.post<POSResponse>(updateurl, posDownload);

  }

  getInvoice(accountNumber: string, workOrderNumber: string, brand:string): Observable<POSResponse> {

    let updateurl = this.userService.getClientAndFmSystemBaseUrl() + '/brand/' + brand  + this.downloadInvoiceUrl;

    let invoiceDownload = new InvoiceDownload();
    invoiceDownload.accountNumber = accountNumber;
    invoiceDownload.workOrderNumber = workOrderNumber;

    return this.http.post<POSResponse>(updateurl, invoiceDownload);
  }

  getVisits(value:any,brand:string, page: number, size: number): Observable<TableResponse> {
    const pageParams = PageParams.getPageParams(page, size);
    let url = this.userService.getClientBaseUrl() + '/brand/' + brand + '/visits';
    if (this.loginStateService.isVisits) {
      url = url + '/property' + '/workOrderId' + '/value/' + value;
    }
    return this.http.get<TableResponse>(url, { params: pageParams });
  }

  getWorkOrders(value:any,brand:string, page:number, size:number): Observable<TableResponse> {
    const pageParams = PageParams.getPageParams(page, size);
    let url = this.userService.getClientBaseUrl() + '/brand/' + brand + '/workorders';
    if (this.loginStateService.isWorkOrders) {
      url = url + '/property' + '/workOrderNumber' + '/value/' + value;
    }
    return this.http.get<TableResponse>(url, { params: pageParams });
  }

  acceptWO(workOrderNumber: any): Observable<TableResponse> {
      let url = this.userService.getBaseUrl() + '/acceptworkorder' + '/fmSystem/' + this.userService.getFmSystemId() + '/client/' + this.userService.getClientId() + '/workOrder/' + workOrderNumber;
      let body = {
        "woList":
        workOrderNumber
      };
      return this.http.post<TableResponse>(url, body);
  }

  rejectWO(workOrderNumber: any): Observable<TableResponse> {
    let url = this.userService.getBaseUrl() + '/rejectworkorder' + '/fmSystem/' + this.userService.getFmSystemId() + '/client/' + this.userService.getClientId() + '/workOrder/' + workOrderNumber;
    let body = {
      "woList":
      workOrderNumber
    };
    return this.http.post<TableResponse>(url, body);
}
  
workOrderHistory(workOrderNumber: any, page: number, size:number): Observable<TableResponse>{
  const pageParams = PageParams.getPageParams(page, size);
  let url = (this.userService.getBaseUrl() + '/workOrderHistory/brand' + '/' +  this.userService.getBrand() + '/fmSystem/' + this.userService.getFmSystemId() + '/workOrderId/' + workOrderNumber);
  return this.http.get<TableResponse>(url, { params: pageParams });

}


invoicePopUp(workOrderNumber: any, page:number, size:number): Observable<TableResponse>{
  const pageParams = PageParams.getPageParams(page, size);
  let url = (this.userService.getBaseUrl() + '/invoicePopup/brand' + '/' +  this.userService.getBrand() + '/fmSystem/' + this.userService.getFmSystemId() +  '/client/' + this.userService.getClientId() + '/workOrderNumber/' + workOrderNumber);
  return this.http.get<TableResponse>(url, { params: pageParams });

}

pestInformation(workOrderNumber: any, page: number, size:number): Observable<TableResponse>{
  const pageParams = PageParams.getPageParams(page, size);
  let url = (this.userService.getBaseUrl() + '/pestInformation/brand' + '/' +  this.userService.getBrand() + '/fmSystem/' + this.userService.getFmSystemId() +  '/client/' + this.userService.getClientId() + '/workOrderNumber/' + workOrderNumber);
  return this.http.get<TableResponse>(url, { params: pageParams });

}


}
